import useMediaQuery from 'hooks/useMediaQuery';
import HeaderNavigationLink from '../HeaderNavigationLink';
import ProductDropdownComponent from './DropdownComponents/ProductDropdownComponent';

const ProductDropdown = ({ items, onClick }) => {
    const isTablet = useMediaQuery('max-width: 1023px');

    return (
        <>
            <div className="header-nav__item__dropdown-section col-4">
                <div className="link">{items.residential_section}</div>
                {
                    items.residential_items.map((item, index) => (
                        <HeaderNavigationLink
                            key={index}
                            data={item}
                            onClick={onClick}
                        />
                    ))
                }
            </div>
            <div className="header-nav__item__dropdown-section col-4">
                <div className="link">{items.datacenter_section}</div>
                {items.datacenter_items.map((item, index) => (
                    <HeaderNavigationLink
                        key={index}
                        data={item}
                        onClick={onClick}
                    />
                ))}
            </div>
            {!isTablet && (
                <div className="header-nav__item__dropdown-section col-4">
                    <ProductDropdownComponent />
                </div>
            )}
        </>
    );
};

export default ProductDropdown;
